import React from 'react'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

const ShimmerContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px;
  background: var(--color-surface-panel);
`

const ShimmerElement = styled.div`
  background: linear-gradient(90deg, var(--color-hover-neutral) 25%, var(--color-border-default) 50%, var(--color-hover-neutral) 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: 8px;
`

const TableContainer = styled.div`
  width: 100%;
`

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr 1fr 1fr 1fr 1fr 120px;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--color-border-default);
  margin-bottom: 8px;
`

const HeaderCell = styled(ShimmerElement)`
  height: 24px;
`

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr 1fr 1fr 1fr 1fr 120px;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-border-default);
  margin-bottom: 4px;
`

const RowCell = styled(ShimmerElement)`
  height: 20px;
`

const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
  margin-top: 16px;
`

const PaginationElement = styled(ShimmerElement)`
  height: 32px;
  width: 40px;
`

const ShimmerBlock = () => {
  return (
    <ShimmerContainer>
      <TableContainer>
        <TableHeader>
          <HeaderCell />
          <HeaderCell />
          <HeaderCell />
          <HeaderCell />
          <HeaderCell />
          <HeaderCell />
          <HeaderCell />
        </TableHeader>
        {[...Array(8)].map((_, i) => (
          <TableRow key={i}>
            <RowCell />
            <RowCell />
            <RowCell />
            <RowCell />
            <RowCell />
            <RowCell />
            <RowCell />
          </TableRow>
        ))}
      </TableContainer>
      
      <PaginationContainer>
        <PaginationElement />
        <PaginationElement />
        <PaginationElement />
        <PaginationElement />
      </PaginationContainer>
    </ShimmerContainer>
  )
}

export default ShimmerBlock 